<template>
  <div class="data-form layers" :class="{ 'eng': SC.U === ENG, 'chi': SC.U === CHI, desktop: bigEnough }">
    <div class="scroller" ref="scroller">
      <div class="long-content" ref="content">
        <div class="top-taller"></div>

        <div class="all-col">
          <!-- <div class="all-row center step-3">
            <img class="step-3-not-desktop" src="./img/step3.svg" alt="">
            <img class="step-3-only-desktop" src="./img/step3-1440.svg" alt="">
          </div> -->
          <!-- <div class="all-row step-row">
            {{ T('/data-form@step3') }}
          </div> -->
          <div class="all-row step-desc">
            {{ T('/data-form@step-desc-1') }}
            <br />
            {{ T('/data-form@step-desc-2') }}
            <!--
            <br />
            {{ T('/data-form@step-desc-3') }} -->
          </div>
          <div class="all-row cosmetics">
            <img class="cosmetics-header-image" src="./img/cosmetics.png">
          </div>

          <div class="all-row center">
            <form class="form" @submit.prevent="goSubmit">
              <div class="first-name">
                {{ T('/data-form@first-name') }} <span class="red" v-if="required.firstName">{{ T('/data-form@red') }}</span>
              </div>
              <div class="first-name-field">
                <input class="input-field" v-model="form.firstName" />
              </div>

              <div class="last-name">
                {{ T('/data-form@last-name') }} <span class="red" v-if="required.lastName">{{ T('/data-form@red') }}</span>
              </div>
              <div class="last-name-field">
                <input class="input-field" v-model="form.lastName" />
              </div>

              <div class="area-mobile-row">
                <div class="area-code">
                  <div class="area-code-title">
                    {{ T('/data-form@area-code') }}
                  </div>
                  <div class="area-code-input">
                    <select class="select-field" v-model="form.areaCode">
                      <option value="852">+852</option>
                      <option value="853">+853</option>
                      <option value="86">+86</option>
                    </select>

                    <svg width="8px" height="8px" viewBox="0 0 8 8" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                        <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
                        <desc>Created with Sketch.</desc>
                        <defs></defs>
                        <g id="Layout-v9" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                            <g id="06a-fill-form" transform="translate(-103.000000, -624.000000)" fill="#CEBC9E">
                                <polygon id="Triangle-2" transform="translate(107.000000, 628.000000) scale(1, -1) translate(-107.000000, -628.000000) " points="107 624 111 632 103 632"></polygon>
                            </g>
                        </g>
                    </svg>
                  </div>
                </div>
                <div class="mobile-num">
                  <div class="mobile-num-title">
                    {{ T('/data-form@contact-phone') }} <span class="red" v-if="required.mobileNumber">{{ T('/data-form@red') }}</span>
                  </div>
                  <div class="mobile-num-input">
                    <input class="input-field" type="text" v-model="form.mobileNumber" />
                  </div>
                </div>
              </div>

              <div class="email-address">
                {{ T('/data-form@email-address') }} <span class="red" v-if="required.email">{{ T('/data-form@red') }}</span>
              </div>
              <div class="email-address-field">
                <input type="email" class="input-field" v-model="form.email" />
              </div>

              <div class="news-letter" v-if="SC.U === ENG">
                I would like to receive the latest news via
              </div>
              <div class="news-letter" v-if="SC.U === CHI">
                本人希望透過以下途徑收取最新資訊，包括優惠詳情:
              </div>

              <div class="news-letter-boxes">

                <div class="checker-group">

                  <svg @click="form.getEmail = !form.getEmail" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
                      <desc>Created with Sketch.</desc>
                      <defs></defs>
                      <g id="Layout-TC" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="06a-fill-form-TC" transform="translate(-35.000000, -745.000000)">
                              <rect id="Rectangle-9-Copy" stroke="#CEBC9E" x="35.5" y="745.5" width="23" height="23"></rect>
                              <g v-if="form.getEmail" id="iconmonstr-check-mark-9" transform="translate(40.000000, 751.000000)" fill="#CEBC9E" fill-rule="nonzero">
                                  <path d="M0,6.0671361 L1.19758333,4.96922929 C2.59816667,5.64174785 3.48658333,6.15279251 5.06041667,7.26632584 C8.01966667,3.93440725 9.97558333,2.24385068 13.6103333,0 L14,0.888974631 C11.00225,3.48413234 8.80716667,6.37503617 5.64608333,12 C3.696,9.72200251 2.39458333,8.2693161 0,6.0671361 Z" id="Shape"></path>
                              </g>
                          </g>
                      </g>
                  </svg>

                  <div class="checkbox-words">

                    {{ T('/data-form@email') }}
                  </div>
                </div>

                <div class="checker-group">
                  <svg @click="form.getMobile = !form.getMobile" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
                      <desc>Created with Sketch.</desc>
                      <defs></defs>
                      <g id="Layout-TC" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="06a-fill-form-TC" transform="translate(-35.000000, -745.000000)">
                              <rect id="Rectangle-9-Copy" stroke="#CEBC9E" x="35.5" y="745.5" width="23" height="23"></rect>
                              <g v-if="form.getMobile" id="iconmonstr-check-mark-9" transform="translate(40.000000, 751.000000)" fill="#CEBC9E" fill-rule="nonzero">
                                  <path d="M0,6.0671361 L1.19758333,4.96922929 C2.59816667,5.64174785 3.48658333,6.15279251 5.06041667,7.26632584 C8.01966667,3.93440725 9.97558333,2.24385068 13.6103333,0 L14,0.888974631 C11.00225,3.48413234 8.80716667,6.37503617 5.64608333,12 C3.696,9.72200251 2.39458333,8.2693161 0,6.0671361 Z" id="Shape"></path>
                              </g>
                          </g>
                      </g>
                  </svg>

                  <div class="checkbox-words">
                    {{ T('/data-form@mobile') }}
                  </div>
                </div>

                <div class="checker-group">
                  <svg @click="form.getSMS = !form.getSMS" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                      <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
                      <desc>Created with Sketch.</desc>
                      <defs></defs>
                      <g id="Layout-TC" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                          <g id="06a-fill-form-TC" transform="translate(-35.000000, -745.000000)">
                              <rect id="Rectangle-9-Copy" stroke="#CEBC9E" x="35.5" y="745.5" width="23" height="23"></rect>
                              <g v-if="form.getSMS" id="iconmonstr-check-mark-9" transform="translate(40.000000, 751.000000)" fill="#CEBC9E" fill-rule="nonzero">
                                  <path d="M0,6.0671361 L1.19758333,4.96922929 C2.59816667,5.64174785 3.48658333,6.15279251 5.06041667,7.26632584 C8.01966667,3.93440725 9.97558333,2.24385068 13.6103333,0 L14,0.888974631 C11.00225,3.48413234 8.80716667,6.37503617 5.64608333,12 C3.696,9.72200251 2.39458333,8.2693161 0,6.0671361 Z" id="Shape"></path>
                              </g>
                          </g>
                      </g>
                  </svg>

                  <div class="checkbox-words">
                    {{ T('/data-form@sms') }}
                  </div>
                </div>



              </div>

              <div class="privacy">

                <svg @click="form.agree = !form.agree" width="24px" height="24px" viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                    <!-- Generator: Sketch 49.1 (51147) - http://www.bohemiancoding.com/sketch -->
                    <desc>Created with Sketch.</desc>
                    <defs></defs>
                    <g id="Layout-TC" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                        <g id="06a-fill-form-TC" transform="translate(-35.000000, -745.000000)">
                            <rect id="Rectangle-9-Copy" stroke="#CEBC9E" x="35.5" y="745.5" width="23" height="23"></rect>
                            <g v-if="form.agree" id="iconmonstr-check-mark-9" transform="translate(40.000000, 751.000000)" fill="#CEBC9E" fill-rule="nonzero">
                                <path d="M0,6.0671361 L1.19758333,4.96922929 C2.59816667,5.64174785 3.48658333,6.15279251 5.06041667,7.26632584 C8.01966667,3.93440725 9.97558333,2.24385068 13.6103333,0 L14,0.888974631 C11.00225,3.48413234 8.80716667,6.37503617 5.64608333,12 C3.696,9.72200251 2.39458333,8.2693161 0,6.0671361 Z" id="Shape"></path>
                            </g>
                        </g>
                    </g>
                </svg>

                <div class="agreement" v-if="SC.U === ENG">
                  I have read and understood the&nbsp;<span class="link" @click="goPrivacy"> Personal Information Collection Statement</span>.
                </div>
                <div class="agreement" v-if="SC.U === CHI">
                  本人已細閱及同意有關<span class="link" @click="goPrivacy">收集個人資料聲明</span>
                </div>

              </div>

              <input type="submit" ref="submitbtn" style="display: none;" />
              <CTA :use500="true" :text="T('/data-form@submit')" @action="clickSubmit()" />

              <!--
              <div class="submit" @click="clickSubmit()">
                <input type="submit" ref="submitbtn" style="display: none;" />
                <img class="submit-frame" src="./img/submit.svg" alt="">
                <div class="submit-text">
                  {{ T('/data-form@submit') }}
                </div>
              </div> -->

              <div class="no-thanks" @click="goUnlock()">
                <span class="underline">
                  {{ T('/data-form@no-thanks') }}
                </span>
              </div>

            </form>
          </div>
        </div>

        <div class="bottom-taller"></div>
      </div>
    </div>
    <FloatMenu class="float-menu" @diamond="() => { fsMenu = !fsMenu }" />
    <FullMenu class="full-menu" v-show="fsMenu" @close="() => { fsMenu = false }" @lang="() => { Text.toggle() }" />
    <PrivacyPopUp class="privacy-popup-abs" v-if="privacyPopUp" @close="() => { privacyPopUp = false }" />
  </div>
</template>

<script>
import FloatMenu from '@/components/DOM/FloatMenu/FloatMenu.vue'
import FullMenu from '@/components/DOM/FullMenu/FullMenu.vue'
import * as Text from '@/components/DOM/Text/Text.js'
import * as Server from '@/components/DOM/Server/Server.js'
import * as PhotoStore from '@/components/DOM/PhotoStore/PhotoStore.js'

import * as ScrollMonitor from '@/components/Parts/ScrollMonitor/ScrollMonitor.js'
import CTA from '@/components/DOM/CTA/CTA.vue'

import PrivacyPopUp from '@/components/Pages/Privacy/PrivacyPopUp.vue'

// import Instruction from './Instruction.vue'

export default {
  components: {
    FloatMenu,
    FullMenu,
    CTA,
    PrivacyPopUp
    // Instruction
  },
  data () {
    // var self = this
    return {
      Text,
      PhotoStore,
      SC: Text.state,
      T: Text.T,
      ENG: Text.ENG,
      CHI: Text.CHI,

      fsMenu: false,
      clean () {},
      form: false,
      bigEnough: window.innerWidth >= 768,
      privacyPopUp: false,
      required: {
        firstName: false,
        lastName: false,
        mobile: false,
        email: false
      }
    }
  },
  computed: {
    formJSON () {
      return JSON.stringify(this.form)
    }
  },
  watch: {
    formJSON () {
      PhotoStore.state.formData = this.form
    },
    bigEnough (oldV, newV) {
      if (oldV !== newV) {
        window.location.reload()
      }
    }
  },
  mounted () {
    ScrollMonitor.setPercentage(0)
    // this.setupScroll()
    window.addEventListener('resize', () => {
      // this.setupScroll()
      this.bigEnough = window.innerWidth >= 768
    })
    PhotoStore.state.formData = PhotoStore.state.formData || {
      firstName: '',
      lastName: '',
      areaCode: '852',
      mobileNumber: '',
      email: '',

      getEmail: true,
      getMobile: true,
      getSMS: true,
      agree: false
    }
    // hydrate
    this.form = PhotoStore.state.formData
  },
  methods: {
    goPrivacy () {
      if (window.innerWidth < 768) {
        this.$router.push('/privacy')
      } else {
        this.privacyPopUp = true
      }
    },
    clickSubmit () {
      this.$refs['submitbtn'].click()
    },
    goSubmit () {
      var needsStop = false
      if (!this.form.agree) {
        window.alert('You need to agree the terms to proceed.')
        needsStop = true
      }

      if (!this.form.firstName) {
        this.required.firstName = true
        needsStop = true
      } else {
        this.required.firstName = false
      }

      if (!this.form.lastName) {
        this.required.lastName = true
        needsStop = true
      } else {
        this.required.lastName = false
      }

      if (!this.form.mobileNumber && (this.form.getMobile || this.form.getSMS)) {
        this.required.mobileNumber = true
        needsStop = true
      } else {
        this.required.mobileNumber = false
      }

      if (!this.form.email && (this.form.getEmail)) {
        this.required.email = true
        needsStop = true
      } else {
        this.required.email = false
      }

      this.$forceUpdate()
      if (needsStop) {
        return
      }

      let newData = {
        ...this.form
      }
      delete newData.agree
      // Server.recordStep({ step: 2 })
      Server.submitForm(newData).then(() => {
        this.$router.push('/kids-wishes')
      })
    },
    goUnlock () {
      // @____@
      // @o@
      this.$router.push('/kids-wishes')
    },
    setupScroll () {
      this.clean()
      var scroller = this.$refs['scroller']
      if (!scroller) {
        return
      }
      var content = this.$refs['content']
      var scrollerHeight = scroller.getBoundingClientRect().height
      var ccontentHeight = content.getBoundingClientRect().height
      var onScroll = () => {
        this.scrollPos = scroller.scrollTop

        ScrollMonitor.state.percentage = 0.2 * (scroller.scrollTop) / (ccontentHeight - scrollerHeight)
        // console.log(ScrollMonitor.state.percentage)
      }
      scroller.addEventListener('scroll', onScroll, false)

      this.clean = () => {
        if (scroller) {
          scroller.removeEventListener('scroll', onScroll)
        }
      }
    }
  },
  beforeDestroy () {
    this.clean()
  }
}
</script>

<style scoped>
.data-form{
  color: white;
}
.full-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.float-menu{
  position: absolute;
  top: 0px;
  left: 0px;
}
.privacy-popup-abs{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  height: 100%;
}
.layers{
  width: 100%;
  height: 100%;
  position: relative;
  overflow:hidden;
}

.scroller{
  position: absolute;
  top: 0px;
  left: 0px;

  width: 100%;
  height: 100%;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  color: white;
  overflow-x: hidden;
}
.top-taller{
  height: 100px;
}
.desktop .top-taller{
  height: 100px;
}
.taller{
  height: 75vh;
}
.bottom-taller{
  height: 1px;
}

.all-col{
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  flex-direction: column;
}

.all-row{
  width: 100%;
  max-width: 500px;
}

@media screen and (max-width: 321px){
  .all-row{
    max-width: 310px;
  }
}

.step-row{
  margin-top: 5px;
  text-transform: uppercase;
  /* step 3: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 10px;
  /* color: #CEBC9E; */
  color: white;
  letter-spacing: 1.24px;
  text-align: center;
  line-height: 26px;
  transform: translateX(138px);
}

.center{
  display: flex;
  justify-content: center;
}

.step-desc{
  margin-top: 5px;
  text-transform: uppercase;
  /* Would you like to jo: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.8px;
  text-align: center;
  line-height: 22px;
}

.cosmetics{
  margin-top: 20px;
}
.cosmetics img{
  width: 100%;
}

.form{
  margin-top: 20px;
  width: 100%;
  max-width: 304px;
}

@media screen and (max-width: 321px){
  .form{
    max-width: 280px;
  }
}

.first-name{
  /* First Name: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 26px;
}

.first-name-field{
  /* Line 3: */
  height: 40px;
  border-bottom: 1px solid rgba(206, 188, 158, 0.5);
}

.last-name{
  margin-top: 10px;
  /* First Name: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 26px;
}

.last-name-field{
  /* Line 3: */
  height: 40px;
  border-bottom: 1px solid rgba(206, 188, 158, 0.5);
}

.input-field{
  appearance: none;
  background: transparent;
  outline: none;
  border: none;
  color: white;
  font-size: 20px;
  width: 100%;
  height: 100%;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
}
.select-field{
  appearance: none;
  background: transparent;
  outline: none;
  border: none;
  height: 100%;
  width: 100%;

  /* +852: */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 17px;
  color: #FFFFFF;
  letter-spacing: 2.9px;
  /* line-height: 26px; */
}

.area-mobile-row{
  /* Line 3: */
  border-bottom: 1px solid rgba(206, 188, 158, 0.5);
  display: flex;
}

.area-code{
  width: 33.33%;
  border-right: 1px solid rgba(206, 188, 158, 0.5);
}
.mobile-num {
  width: 66.67%;
  /* mobile: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 26px;
}

.area-code-title, .mobile-num-title{
  padding-top: 10px;
  /* height: 35px; */
  /* text-transform: uppercase; */
  /* area code: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 26px;
}

.mobile-num-title{
  margin-left: 10px;
}

.mobile-num-input,
.area-code-input{
  height: 40px;
}

.mobile-num-input input{
  margin-left: 10px;
  margin-bottom: 10px;
}
.area-code-input input{
  margin-bottom: 10px;
}

.area-code-input{
  display: flex;
  justify-content: space-between;
  align-items: center;
}


.area-code-input {
  position: relative;
}
.area-code-input svg{
  position: absolute;
  top: 17px;
  right: 31px;
}

.email-address{
  margin-top: 10px;
  /* First Name: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 26px;
}

.email-address-field{
  /* Line 3: */
  height: 40px;
  border-bottom: 1px solid rgba(206, 188, 158, 0.5);
}

.news-letter {
  margin-top: 10px;
  /* text-transform: uppercase; */
  /* I would like to rece: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 1.5px;
  line-height: 26px;
}

.news-letter-boxes{
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  height: 40px;
  border-bottom: 1px solid rgba(206, 188, 158, 0.5);
}

.checkbox-words{
  margin-left: 10px;
  /* E-Mail: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 2.05px;
  line-height: 26px;
}


.checker-group{
  display: flex;
  margin-left: 20px;
}
.checker-group:nth-child(1){
  margin-left: 0px;
}

.privacy{
  margin-top: 10px;
  display: flex;
}
.privacy svg{
  min-width: 24px;
}
.agreement{
  margin-left: 10px;
  /* I have read and unde: */
  /* border: 1px solid #FFFFFF; */
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #FFFFFF;
  letter-spacing: 0.8px;
  line-height: 18px;
}
.eng .agreement{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.agreement span{
  cursor: pointer;
}
.chi .agreement{
  margin-top: 5px;
  /* display: flex;
  align-items: center;
  flex-wrap: wrap; */
}

.submit{
  margin-top: 10px;
  cursor: pointer;
  position: relative;
  width: 100%;
}
.submit-frame{
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
  /* Submit: */
  /* border: 0 solid #FFFFFF; */
}

.submit-text{
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 58px;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 16px;
  color: #FFFFFF;
  letter-spacing: 2px;
  text-align: center;
  line-height: 26px;
}

@media screen and (min-width: 374px) {
  .submit-text{
    height: 63px;
  }
}

.no-thanks{
  cursor: pointer;
  margin-top: 10px;
  margin-bottom: 10px;

  /* No, thank you!: */
  border: 0 solid #CEBC9E;
  font-family: CronosPro-LtDisp, PingFang-SC-Regular;
  font-size: 14px;
  color: #CEBC9E;
  letter-spacing: 1px;
  text-align: center;
  line-height: 26px;

  height: 30px;
}
.no-thanks .underline{
  border-bottom: 1px solid #CEBC9E;
}

.link{
  transform: translateY(1px);
  box-sizing: border-box;
  border-bottom: 1px solid rgba(206, 188, 158, 0.5);
}

.step-3-not-desktop{
}

.step-3-only-desktop{
  display: none;
}

@media screen and (min-width: 767.77px) {
/* @media screen and (min-width: 1439px) { */
  .step-3-not-desktop{
    display: none;
  }
  .step-3-only-desktop{
    display: block;
  }
  .step-row{
    display: block;
    font-size: 11px;
    transform: translateX(280px);
  }
  .form{
    max-width: 500px;
  }
  .submit-text{
    height: 85px;
  }
  .step-desc{
    font-size: 20px;
    line-height: 30px;
    margin-top: 20px;
  }
  .no-thanks{
    margin-top: 25px;
    margin-bottom: 30px;
    font-size: 14px;
  }
  .all-row.cosmetics{
    max-width: 600px;
  }
  .cosmetics-header-image{
    height: 400px;
  }
  .privacy{
    margin-top: 20px;
  }
  .form .cta-row{
    margin-top: 55px;
  }
}

.red{
  color: red;
}


</style>



// WEBPACK FOOTER //
// src/components/Pages/DataForm/DataForm.vue